import { render, staticRenderFns } from "./Dict.vue?vue&type=template&id=96b4a398&scoped=true"
import script from "./Dict.vue?vue&type=script&lang=js"
export * from "./Dict.vue?vue&type=script&lang=js"
import style0 from "./Dict.vue?vue&type=style&index=0&id=96b4a398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b4a398",
  null
  
)

export default component.exports